import * as moment from "moment";
import {CustomFunctionReturn} from "../../slick-grid/models/custom-function-return";
import Timer = NodeJS.Timer;
import {SlickGridComponent} from "../../slick-grid/slick-grid.component";

export class FilterByDateRange{
    constructor(){

    }

    private dates: {start: Date, end: Date, startFull: boolean, endFull: boolean};
    public field: string[];
    public reserveField: string[];
    public view: Slick.Data.DataView<any>;
    public grid: SlickGridComponent;
    private timeout: Timer

    public readonly setDates = (dates: {start: Date, end: Date, startFull: boolean, endFull: boolean}): void => {
        if (this.timeout){
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        this.timeout = setTimeout(() => {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.dates = dates;
            // console.log('setDates 1')
            this.grid && this.grid.setCustomRowHeight && this.grid.removeEmptyRows();
            // console.log('setDates 2')
            this.view && this.view.refresh();
            // console.log('setDates 3')
            this.grid && this.grid.setCustomRowHeight && this.grid.addEmptyRows()
            // console.log('setDates 4')
        }, 100)

    }

    private filterByDateRange = (data: any): boolean => {
        // console.log(this.field, this.dates,data, 'filterByDateRange');
        const getDateData = (arrPosition: number): string => {
            return data[this.field[arrPosition]]
                ? data[this.field[arrPosition]]
                : this.reserveField[arrPosition]
                    ? data[this.reserveField[arrPosition]]
                    : null
        }
        if (this.field.length === 1){
            // if (moment.isMoment(data[this.field[0]])){
            //     let item = data[this.field[0]].is;
            //     return item.isBetween(this.dates.start, this.dates.end, null, '[]')
            // } else {
            //     let check = new Date(data[this.field[0]]);
                let check = new Date(getDateData(0));
                return check >= this.dates.start && check <= this.dates.end
            // }
        } else if (this.field.length > 1) {
            // if (moment.isMoment(data[this.field[0]])){
            //     let startDate = data[this.field[0]];
            //     let endDate = data[this.field[1]];
            //     if (!this.dates.endFull){
            //         return startDate.isSameOrBefore(this.dates.end, 'day') && endDate.isSameOrAfter(this.dates.start, 'day');
            //     } else{
            //         return startDate.isSameOrBefore(this.dates.end, 'day') && endDate.isSameOrAfter(this.dates.start, 'day') ||
            //             startDate.isSameOrAfter(this.dates.end, 'day');
            //     }
            // } else {
            const getDateData = (arrPosition: number): string => {
                return data[this.field[arrPosition]]
                    ? data[this.field[arrPosition]]
                    : this.reserveField[arrPosition]
                        ? data[this.reserveField[arrPosition]]
                        : null
            }

            let startDate = new Date(getDateData(0)),
                endDate = new Date(getDateData(1));
            if (!this.dates.endFull){
                // console.log(startDate <= this.dates.end, this.dates.start <= endDate, '!this.dates.endFull')
                return startDate <= this.dates.end && this.dates.start <= endDate
            } else {
                return startDate <= this.dates.end && this.dates.start <= endDate ||
                    startDate >= this.dates.end
            }

            // }
        }
        return true;
    };

    public filter = (data: any): CustomFunctionReturn => {
        // console.log(this.field, this.dates, 'filter');
        if (!this.field || !this.dates){
            return new CustomFunctionReturn(false, false);
        } else{
            let res = new CustomFunctionReturn(true, this.filterByDateRange(data));
            // console.log(data, res, 'filter')
            return res
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/filter-by-date-range.ts